import { createSlice } from '@reduxjs/toolkit';

const initialParentCLientId = {
    parentClientId : ''
}

const parentClientSlice = createSlice({
    name: 'parentClientId',
    initialState: initialParentCLientId,
    reducers : {
        updateParentClientId(state, action) {
            state.parentClientId = action.payload;
        },
        resetParentClientId: () => initialParentCLientId,
    }
})

export const parentCLientIdActions = parentClientSlice.actions;

export default parentClientSlice.reducer;